const problemDict = {
    "weird-algorithm": "Weird Algorithm",
    "missing-number": "Missing Number",
    "repetitions": "Repetitions",
    "increasing-array": "Increasing Array",
    "permutations": "Permutations",
    "number-spiral": "Number Spiral",
    "two-knights": "Two Knights",
    "two-sets": "Two Sets",
    "bit-strings": "Bit Strings",
    "trailing-zeros": "Trailing Zeros",
    "coin-piles": "Coin Piles",
    "palindrome-reorder": "Palindrome Reorder",
    "gray-code": "Gray Code",
    "towers-of-hanoi": "Towers of Hanoi",
    "creating-strings": "Creating Strings",
    "apple-division": "Apple Division",
    "chessboard-and-queens": "Chessboard and Queens",
    "digit-queries": "Digit Queries",
    "grid-paths": "Grid Paths",
    "distinct-numbers": "Distinct Numbers",
    "binary-search": "A Note on Binary Search",
    "milk-factory": "USACO Bronze Milk Factory Problem",
    "subarray-sums": "Subarray Sums",
}

export default problemDict;